import { apiRequest } from "../utils/api";

const GetReportingManagerForSession = async id => {
  const response = await apiRequest.get(
    `/api/getReportingManagerBySessionId?session_id=${id}`
  );
  if (response.status === 200) {
    const data = response.data.data;
    return data;
  } else {
    return false;
  }
};
export default GetReportingManagerForSession;
